/*
 * Loads MathLive on first use, so its ~800 KB bundle stays out of the main
 * chunk. Its fonts come from mathlive/fonts.css, which webpack bundles, so
 * MathLive must not try to fetch them from a directory of its own.
 */

let pending = null;

/** @returns {Promise<typeof import('mathlive')>} */
export function loadMathLive() {
    if (!pending) {
        pending = Promise.all([
            import(/* webpackChunkName: "mathlive" */ 'mathlive'),
            import(/* webpackChunkName: "mathlive" */ 'mathlive/fonts.css'),
        ]).then(([mathlive]) => {
            mathlive.MathfieldElement.fontsDirectory = null;
            mathlive.MathfieldElement.soundsDirectory = null;
            return mathlive;
        });
        // A failed load (e.g. offline) can be retried next time.
        pending.catch(() => {
            pending = null;
        });
    }
    return pending;
}
